import * as React from 'react';
import IconProps from '@shared/icons/types/IconProps';

function SvgBsStopFill({ size, color, ...props }: IconProps): React.JSX.Element {
	const finalSize = size !== undefined ? size : 16;
	const finalColor = color !== undefined ? color : 'currentColor';
	return (
		<svg
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 20 20"
			width={finalSize}
			height={finalSize}
			{...props}
		>
			<path
				d="M6.25 4.375H13.75C14.2473 4.375 14.7242 4.57254 15.0758 4.92417C15.4275 5.27581 15.625 5.75272 15.625 6.25V13.75C15.625 14.2473 15.4275 14.7242 15.0758 15.0758C14.7242 15.4275 14.2473 15.625 13.75 15.625H6.25C5.75272 15.625 5.27581 15.4275 4.92417 15.0758C4.57254 14.7242 4.375 14.2473 4.375 13.75V6.25C4.375 5.75272 4.57254 5.27581 4.92417 4.92417C5.27581 4.57254 5.75272 4.375 6.25 4.375Z"
				fill={finalColor}
			/>
		</svg>
	);
}
export default SvgBsStopFill;
